
export enum CustomFieldParent {
    Quote = 'Quote',
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    Account = 'Account',
    Contact = 'Contact',
    Zone = 'Zone',
    Code = 'Code',
    Asset = 'Asset',
    Lead = 'Lead',
    Opportunity = 'Opportunity',
    Catalogue = 'Catalogue',
    Project = 'Project',
    Site = 'Site',
    Employee = 'Employee',
    // Equipment = 'Equipment',
    // EquipmentSerialised = 'EquipmentSerialised',
}